import React from 'react';
import { useTranslation } from 'react-i18next';

interface StarRatingProps {
  value: number;
  onChange?: (v: number) => void;
  readOnly?: boolean;
  size?: number;
  ariaLabel?: string;
  activeColor?: string;
}

const StarRating: React.FC<StarRatingProps> = ({ value, onChange, readOnly, size = 22, ariaLabel, activeColor = '#f59e0b' }) => {
  const { t } = useTranslation();
  const stars = [1, 2, 3, 4, 5];
  const label = ariaLabel || String(t('portal.lesson.detail.star_rating', 'Star rating'));
  return (
    <div role={readOnly ? 'img' : 'radiogroup'} aria-label={label} style={{ display: 'inline-flex', gap: 4 }}>
      {stars.map((s) => {
        const filled = value >= s;
        return (
          <button
            key={s}
            type="button"
            role={readOnly ? undefined : 'radio'}
            aria-checked={!readOnly ? value === s : undefined}
            aria-label={String(t('portal.lesson.detail.stars_label', '{{count}} star', { count: s }))}
            onClick={() => { if (!readOnly && onChange) onChange(s); }}
            disabled={!!readOnly}
            style={{
              width: size,
              height: size,
              lineHeight: `${size}px`,
              fontSize: size,
              padding: 0,
              background: 'transparent',
              border: 'none',
              cursor: readOnly ? 'default' : 'pointer',
              color: filled ? activeColor : '#d1d5db'
            }}
          >
            {filled ? '★' : '☆'}
          </button>
        );
      })}
    </div>
  );
};

export default StarRating;
